import React from 'react'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { UseWalletProvider } from 'use-wallet'
import TagManager from 'react-gtm-module'
import Pools from 'views/Pools'
import Pool from 'views/Pool'
import MyPools from 'views/MyPools'
import MyWinnings from 'views/MyWinnings'
import MyTickets from 'views/MyTickets'
import TopBar from 'components/TopBar'
import ModalsProvider from 'contexts/Modals'
import AccountProvider from 'contexts/AccountProvider'
import TokenProvider from 'contexts/TokenProvider'
import PoolListProvider from 'contexts/PoolListProvider'

import theme from 'theme'
import './App.css'

const chainId = parseInt(process.env.REACT_APP_CHAIN_ID)

const tagManagerArgs = {
  gtmId: 'GTM-WFBJ4DF',
}

TagManager.initialize(tagManagerArgs)

function App() {
  return (
    <UseWalletProvider
      chainId={chainId}
      connectors={
        {
          // TODO: use mainnet when in prod
          // walletconnect: { rpcUrl: 'https://mainnet.eth.aragon.network/' },
        }
      }
    >
      <AccountProvider>
        <TokenProvider>
          <PoolListProvider>
            <ThemeProvider theme={theme}>
              <ModalsProvider>
                <Router>
                  <TopBar />
                  <Switch>
                    <Route exact path={'/'}>
                      <Pools />
                    </Route>
                    <Route exact path={`/pools/:poolId`} component={Pool} />
                    <Route exact path={`/mypools`} component={MyPools} />
                    <Route exact path={`/mywinnings`} component={MyWinnings} />
                    <Route exact path={`/mytickets`} component={MyTickets} />
                  </Switch>
                </Router>
              </ModalsProvider>
            </ThemeProvider>
          </PoolListProvider>
        </TokenProvider>
      </AccountProvider>
    </UseWalletProvider>
  )
}

export default App
